import { getGa4MeasurementId, shouldLoadAnalytics } from './config';

const GTAG_SCRIPT_ID = 'nf-gtag-script';

/** @returns {boolean} */
export function isGtagLoaded() {
  if (typeof document === 'undefined') return false;
  if (document.getElementById(GTAG_SCRIPT_ID)) return true;
  return !!document.querySelector('script[src*="googletagmanager.com/gtag/js"]');
}

/**
 * Ensure gtag.js is loaded. Usually injected in index.html at build time via vite.config.js.
 */
export function injectGtag() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return false;
  if (!shouldLoadAnalytics()) return false;

  const measurementId = getGa4MeasurementId();
  if (!measurementId) return false;

  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== 'function') {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }

  if (isGtagLoaded()) return true;

  const script = document.createElement('script');
  script.id = GTAG_SCRIPT_ID;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
  document.head.appendChild(script);

  window.gtag('js', new Date());
  window.gtag('config', measurementId, { send_page_view: false });

  return true;
}
